export enum SpreadsheetImportType {
  tab ='TXT_TAB',
  comma ='TXT_COMMA',
  other ='TXT_OTHER'
};